import * as React from 'react';
import './emailChangePane.module.scss';
import { observer, inject } from 'mobx-react';
import { HomePageState } from '../../../containers/home/states/HomePageState';
import { observable, makeObservable } from 'mobx';
import { EmailChangePaneState } from './states/EmailChangePaneState';
import { FormInput } from '../../atoms/forms/FormInput';
import { CheckBoxInput } from '../../atoms/forms/CheckBoxInput';
import { SettingPane } from '../../molecules/mypage/page';
import { Button } from '@sheinc/shelikes-design-system';
import { GlobalStatesV3 } from '../../../../commonv3/states/GlobalStatesV3';

type Props = {
  homeState: HomePageState;
};

export const EmailChangePane = inject('homeState')(
  observer(
    class EmailChangePane extends React.Component<Props> {
      pageState = new EmailChangePaneState();

      constructor(props: Props) {
        super(props);

        makeObservable(this, {
          pageState: observable,
        });
      }

      componentDidMount(): void {
        this.pageState.init();
      }

      render() {
        const { submitting, formState } = this.pageState;
        return (
          <SettingPane activeMenu="email" title="メールの設定">
            <div styleName="form-label">メールアドレス</div>
            <FormInput
              styleName="email"
              name="email"
              value={formState.getValue('email')}
              placeholder=""
              onChange={(e) => formState.setValue('email', e.target.value)}
              error={formState.getError('email')}
            />
            <div styleName="form-label">配信設定</div>
            <CheckBoxInput
              label={'メールマガジンを許可する'}
              checked={formState.getValue('receive_promotion_emails')}
              onCheck={(checked) => formState.setValue('receive_promotion_emails', checked)}
              error={formState.getError('receive_promotion_emails')}
              className={'receive-promotion-emails-check-box'}
            />
            <div styleName="note">※ キャンペーンやSHEについてのインタビューなどお得な情報をお送りします</div>
            <div styleName="receive-notification-emails">
              <CheckBoxInput
                label={'会員限定のお知らせを許可する'}
                checked={formState.getValue('receive_notification_emails')}
                onCheck={(checked) => formState.setValue('receive_notification_emails', checked)}
                error={formState.getError('receive_notification_emails')}
                className={'receive-notification-emails-check-box'}
              />
            </div>
            <div styleName="note">※ 最新の特別イベント・教室利用についての重要なお知らせをお送りします</div>
            <div styleName="form-submit-button">
              <Button
                isLoading={submitting}
                onClick={() => this.pageState.submit()}
                className="form-submit-button"
                fullWidth={GlobalStatesV3.viewport.isSp}
              >
                保存する
              </Button>
            </div>
          </SettingPane>
        );
      }
    }
  )
);
